import { PROFILE_FAVORITES } from "@/libs/apis/onboarding/reactQueryCacheKeys";
import React from "react";
import ProductCardWrapper from "../../ProductCardWrapper";
import { createTokenIdList, useFavoritedCards } from "./hooks";
import { UserFavoriteProductCardProps } from "./types";

const UserFavoriteProductCard: React.FC<UserFavoriteProductCardProps> = ({
  nfts,
  swooshHandle,
}) => {
  const { data: likedTokensOnPage, isLoading } = useFavoritedCards(
    nfts,
    swooshHandle,
  );

  return (
    <React.Fragment>
      {nfts?.map((nft) => (
        <ProductCardWrapper
          key={nft.tokenId}
          nft={nft}
          keysToUpdate={[
            PROFILE_FAVORITES,
            swooshHandle,
            createTokenIdList(nfts),
          ]}
          swooshHandle={nft.metadata.ownedBy}
          isFavorited={
            isLoading || likedTokensOnPage === undefined
              ? false
              : likedTokensOnPage[nft.tokenId]
          }
        />
      ))}
    </React.Fragment>
  );
};

export default UserFavoriteProductCard;
